var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('div',{staticClass:"pdp modal-wpr"},[_c('div',{ref:"clickableElement",class:`pdp-modal modal ${_vm.flyerOrientation} ${_vm.config.template || ''}`},[_c(_vm.pdpTemplate,{tag:"component",attrs:{"feature-config-path":_vm.featurePath,"product":_vm.product}})],1),_vm._v(" + ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }